<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import DocumentList from '../../components/js/Components/Document/DocumentList.vue'
import BlockContent from '../../components/js/Components/UI/Content/BlockContent.vue'
import LazyContent from '../../components/js/Components/UI/Loading/LazyContent.vue'
import useUser from '../../Composables/User/useUser.ts'
import ContractRestructuringStatus from '../../Constants/ContractRestructuringStatus.ts'
import type { ContractRestructuring } from '../../Types/restructuring'

type DocumentListType = InstanceType<typeof DocumentList>

const props = defineProps<{
  restructuring: ContractRestructuring | null
}>()

const documentListRef = ref<DocumentListType>()

const { t } = useI18n()
const { isReadOnly } = useUser()
const readonly = computed<boolean>(
  () => isReadOnly.value || props.restructuring?.status === ContractRestructuringStatus.CANCELED,
)

function refreshDocumentList(): void {
  documentListRef.value?.getDocuments()
}
</script>

<template>
  <BlockContent inner-bloc-class="border-contract-yellow">
    <template #header-title>
      <div class="d-flex justify-content-between">
        <h5 class="text-primary">
          {{ t('restructuring.detail.documents.title') }}
        </h5>
      </div>
    </template>

    <LazyContent :loading="!restructuring">
      <DocumentList
        id="contract-restructuring"
        ref="documentListRef"
        style="max-width: 100%; overflow: auto; position: relative"
        :read-only="readonly"
        context="Restructuring\ContractRestructuring"
        :context-id="Number(restructuring?.id)"
        @document-uploaded="refreshDocumentList"
      />

      <template #loader>
        <!-- @TODO: Replace by PlaceholderContent component when available -->
        <div class="row" data-test="contract-restructuring-document-list-loader">
          <div class="col col-md-12 flex-fill">
            <div class="w-100 py-3 mb-3 loading"></div>
            <div class="w-100 py-3 mb-3 loading"></div>
            <div class="w-100 py-3 mb-3 loading"></div>
            <div class="w-100 py-3 mb-3 loading"></div>
          </div>
        </div>
      </template>
    </LazyContent>
  </BlockContent>
</template>
